import {PayloadAction} from "../payload-action.interface";
import {NoteEntity} from "./note.entity";
import {NoteActions} from "./note.actions";

export function NoteReducer(state: Array<NoteEntity> = [], action: PayloadAction) {
  let newState;

  switch (action.type) {
    case NoteActions.REMOVE:
      return removeNote(state, action.payload);
    case NoteActions.ADD:
    case NoteActions.SET:
      newState = removeNote(state, action.payload._id);
      return addNote(newState, action.payload);
    case NoteActions.ADD_ALL:
      return [...action.payload];
    default:
      return state;
  }
}

function addNote(state: Array<NoteEntity>, note: NoteEntity): Array<NoteEntity> {
  return [...state, note];
}

function removeNote(state: Array<NoteEntity>, id: string): Array<NoteEntity> {
  return state.filter((note) => note._id !== id);
}



// WEBPACK FOOTER //
// ./src/store/note/note.reducer.ts